const MetaList = require('module/user/meta_list')
const Role = require('module/user/role')

const log = require('log').create('role_list') // eslint-disable-line

const RoleList = MetaList.extend({

    id: 'roles',

    model: Role,

})

module.exports = RoleList
